import axiosClient from './axiosClient';

const ManageCmsBlogApi = {
  saveHomePageIntakes: (param) => {
    const url = `intakes/update-bulk-intakes-dashboard-display`;
    return axiosClient.put(url, param);
  },
  saveWorkshop: (param) => {
    const url = `workshops/update-bulk-workshops-dashboard-display`;
    return axiosClient.put(url, param);
  },
  logoUpload: (data) => {
    const url = '/logos';
    return axiosClient.post(url, data);
  },
  getCollabrateLogo: () => {
    const url = '/logos';
    return axiosClient.get(url);
  },
  delete: (id) => {
    const url = `/logos/${id}`;
    return axiosClient.delete(url);
  },
  getEnrollStatus: () => {
    const url = '/settings/BASIC_SETTING';
    return axiosClient.get(url);
  },
  saveEnrollStatus: (param) => {
    const url = '/settings';
    return axiosClient.put(url, param);
  },
  homeContent: (type = 'BASIC_SETTING', formData) => {
    const url = `/cms-settings?type=${type}`;
    return axiosClient.post(url, formData);
  },
  getHomeContent: () => {
    const url = `/cms-settings/BASIC_SETTING`;
    return axiosClient.get(url);
  },
};

export default ManageCmsBlogApi;
